export default __webpack_public_path__ + "static/media/Bobby-Baldwin.ede00854.png";